import axios from "axios";
import Config from "../../config/";
import moment from 'moment';
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: {
      'Authorization': localStorage.getItem('token')
    }
  };
}

export function fetchKategori() {
    const url = `${ROOT_URL}featurecatalog`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function fetchPropertyType(fcid, code) {
    const url = `${ROOT_URL}featuretypeproperty?fcid=${fcid}&code=${code}`;
    const request = axios.get(url, cekAuth());
    return request;
}


export function fetchDictionary() {
    const url = `${ROOT_URL}dictionary`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function fetchUnsur(fcid) {
    const url = `${ROOT_URL}featuretype?fcid=${fcid}`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function fetchUnsurCode(fcid, code) {
    const url = `${ROOT_URL}featuretypecode?fcid=${fcid}&code=${code}`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function fetchUnsurDetail(fcid, ftid) {
    const url = `${ROOT_URL}featuretypedetail?fcid=${fcid}&ftid=${ftid}`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function fetchTest(fcid) {
    const url = `http://localhost:8080/users`;
    const request = axios.get(url);
    return request;
}

export function fetchType(fcid) {
    const url = `${ROOT_URL}featuretype?fcid=${fcid}`;
    const request = axios.get(url);
    return request;
}

export function deleteFeatureCatalog(fcid) {
    const url = `${ROOT_URL}featurecatalog/${fcid}`;
    const request = axios.delete(url, cekAuth());
    return request;
}

export function deleteFeatureType(ftid) {
    const url = `${ROOT_URL}featuretype/${ftid}`;
    const request = axios.delete(url, cekAuth());
    return request;
}

export function fetchSearchUnsur_(ptMemberName) {
    const url = `${ROOT_URL}attributesearch?ptMemberName=${ptMemberName}`;
    const request = axios.get(url);
    return request;
}

export function fetchSearchUnsur(fcid,typenya, keyword) {
    const url = `${ROOT_URL}propertyj?fcid=${fcid}&typenya=${typenya}&keyword=${keyword}`;
    const request = axios.get(url);
    return request;
}

export function fetchSearchDomain(lv) {
    const url = `${ROOT_URL}listvaluesearch?lv=${lv}`;
    const request = axios.get(url);
    return request;
}

export function fetchTotalUnsur() {
    const url = `${ROOT_URL}totalunsur`;
    const request = axios.get(url);
    return request;
}
